/* eslint-disable */
import GroupBooking from './GroupBooking';
import CorporateBooking from './CorporateBooking';
import WeddingBooking from './WeddingBooking';
import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api';
const LOGO = 'https://botanix.in/wp-content/uploads/2025/12/Botanix-Nature-Resort-Logo.webp';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', blue:'#FFFFFF',
 red:'#EF4444', redBg:'rgba(239,68,68,.10)', redBorder:'rgba(239,68,68,.25)',
 amber:'#F59E0B', amberBg:'rgba(245,158,11,.10)', amberBorder:'rgba(245,158,11,.25)',
 purple:'#A78BFA', gold:'#D4A017',
 sidebar:'#060E1C', sidebarBorder:'rgba(30,58,95,.6)',
};

const inr = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});
const fmtDate = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short'}) : '——';
const todayStr = new Date().toISOString().slice(0,10);

// NAV ITEMS 
const NAV_SECTIONS = [
 { section:'OVERVIEW', items:[
 { id:'overview', label:'Dashboard', icon:'─' },
 { id:'morning_brief', label:'Morning Brief', },
 { id:'approvals', label:'Approvals', badge:'approvals' },
 { id:'notifications', label:'Notifications', badge:'alerts' },
 ]},
 { section:'OPERATIONS', items:[
 { id:'sales', label:'Sales & Bookings', },
 { id:'front_office', label:'Front Office', },
 { id:'housekeeping', label:'Housekeeping', },
 { id:'kitchen', label:'Kitchen & F&B', },
 { id:'activities', label:'Activities', },
 { id:'events', label:'Events', },
 { id:'maintenance', label:'Maintenance', },
 { id:'horticulture', label:'Horticulture', },
 { id:'inventory', label:'Inventory', },
 ]},
 { section:'FINANCE', items:[
 { id:'accounts', label:'Accounts', },
 { id:'hr', label:'HR & Staff', },
 { id:'engineering', label:'Engineering', },
 ]},
 { section:'ANALYTICS', items:[
 { id:'reports', label:'Reports', },
 { id:'analytics', label:'AI Analytics', },
 { id:'sustainability',label:'Sustainability', },
 ]},
];

// NOTIFICATIONS 
function Notifications() {
 const [selected, setSelected] = useState(null);
 const notifications = [
 { id:1, msg:'VIP Guest Mr. Arjun Mehta (Room 301) checked in', time:'08:45', color:C.gold, detail:'Mr. Arjun Mehta checked in to Room 301. VIP tag applied. Welcome amenities to be arranged by housekeeping.' },
 { id:2, msg:'New 5-star Google review from Sharma Family', time:'08:30', color:C.accent, detail:'Sharma Family left a 5-star review. Review mentions excellent food, decoration and staff hospitality.' },
 { id:3, msg:'Complaint escalated —— Room 205, AC not cooling', time:'08:15', color:C.red, detail:'Guest in Room 205 complained about AC. Maintenance ticket #7 raised. Technician assigned. ETA 30 mins.' },
 { id:4, msg:'Kitchen stock low —— Paneer below reorder level', time:'07:50', color:C.amber, detail:'Paneer stock at 4 kg, reorder level is 10 kg. Emergency purchase request raised by kitchen team.' },
 { id:5, msg:'Wedding group —— Sharma Wedding 310 guests confirmed', time:'07:30', color:C.purple, detail:'Sharma Wedding (BTX-823449) —— 310 guests confirmed for today. Function starts at 7 PM.' },
 { id:6, msg:'Corporate group ABC Ltd arriving at 11 AM', time:'07:00', color:C.blue, detail:'ABC Technologies (BTX-267540) —— 95 delegates arriving at 11 AM. Conference hall setup done.' },
 { id:7, msg:'Maintenance ticket #7 —— Pool pump critical', time:'06:45', color:C.red, detail:'Pool pump Unit-2 failed. Affects day picnic activities. Technician contacted. ETA for repair: 3 hours.' },
 { id:8, msg:'Guest birthday today —— Room 108, Mr. Rohit Kapoor', time:'06:00', color:C.purple, detail:'Mr. Rohit Kapoor (Room 108) celebrating birthday today. Housekeeping to arrange cake and flowers by 6 PM.' },
 ];

 return (
 <div>
 <div style={{ fontWeight:700, fontSize:18, color:C.text, marginBottom:16 }}> Notification Centre</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>Real-time alerts from across the property</div>
 <div style={{ display:'grid', gap:10 }}>
 {notifications.map(n=>(
 <div key={n.id} style={{ background:C.surface, border:`1px solid ${n.color}33`, borderRadius:12, padding:14, display:'flex', gap:12, alignItems:'center' }}>
 <div style={{ width:40, height:40, borderRadius:10, background:`${n.color}20`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, flexShrink:0 }}>{n.icon}</div>
 <div style={{ flex:1 }}>
 <div style={{ fontSize:13, color:C.text, fontWeight:600 }}>{n.msg}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:2 }}>{n.time} today</div>
 </div>
 <button onClick={()=>setSelected(n)} style={{ padding:'5px 14px', background:`${n.color}15`, border:`1px solid ${n.color}33`, borderRadius:6, color:n.color, cursor:'pointer', fontSize:11, fontWeight:600, flexShrink:0 }}>View</button>
 </div>
 ))}
 </div>

 {selected && (
 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.75)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:C.surface, border:`1px solid ${selected.color}44`, borderRadius:16, padding:24, maxWidth:480, width:'100%' }}>
 <div style={{ display:'flex', gap:14, alignItems:'flex-start', marginBottom:16 }}>
 <div style={{ width:44, height:44, borderRadius:10, background:`${selected.color}20`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 }}>{selected.icon}</div>
 <div>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:4 }}>{selected.msg}</div>
 <div style={{ fontSize:12, color:C.text3 }}>{selected.time} today</div>
 </div>
 </div>
 <div style={{ background:`${selected.color}10`, border:`1px solid ${selected.color}30`, borderRadius:10, padding:14, marginBottom:16 }}>
 <div style={{ fontSize:13, color:C.text2, lineHeight:1.7 }}>{selected.detail}</div>
 </div>
 <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
 <button onClick={()=>setSelected(null)} style={{ padding:'9px 18px', background:'none', border:`1px solid ${C.border2}`, borderRadius:8, color:C.text2, cursor:'pointer', fontSize:13 }}>Close</button>
 <button onClick={()=>setSelected(null)} style={{ padding:'9px 22px', background:selected.color, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700 }}> Mark Resolved</button>
 </div>
 </div>
 </div>
 )}
 </div>
 );
}

// GM SALES VIEW 
function GMSales({ bookings }) {

 const [showRoomBooking, setShowRoomBooking] = React.useState(false);
 const [showGroupBooking, setShowGroupBooking] = React.useState(false);
 const [showCorpBooking, setShowCorpBooking] = React.useState(false);
 const [showWeddingBooking, setShowWeddingBooking] = React.useState(false);
 const [showNewBooking, setShowNewBooking] = React.useState(false);
 const load = () => {};
 const total = bookings.length;
 const outstanding= bookings.filter(b=>b.booking_status!=='Cancelled').reduce((s,b)=>s+parseFloat(b.balance_amount||0),0);
 const todayBkgs = bookings.filter(b => (b.start_date||'').slice(0,10) === new Date().toISOString().slice(0,10));
 const revenue = bookings.filter(b=>b.booking_status!=='Cancelled').reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 const confirmed = bookings.filter(b=>b.booking_status==='Confirmed').length;
 const checkedIn = bookings.filter(b=>b.booking_status==='Checked In').length;
 const todayArr = bookings.filter(b=>(b.start_date||'').slice(0,10)===new Date().toISOString().slice(0,10));
 const todayDep = bookings.filter(b=>(b.end_date||'').slice(0,10)===new Date().toISOString().slice(0,10));
 const cancelled = bookings.filter(b=>b.booking_status==='Cancelled').length;

 return (
 <div>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
 <div style={{ fontWeight:700, fontSize:18, color:C.text }}> Sales & Bookings</div>
 <button onClick={()=>setShowNewBooking(true)}
 style={{ padding:'10px 20px', background:C.accent, border:'none', borderRadius:10, color:'#fff', cursor:'pointer', fontSize:14, fontWeight:700 }}>
 + New Booking
 </button>
 </div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>All bookings across the property</div>

 <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 }}>
 {[
 { label:'Total Bookings', value:total, color:C.accent },
 { label:"Today's Bookings", value:todayBkgs.length, color:'#FFFFFF' },
 { label:'Total Revenue', value:inr(revenue), icon:'₹', color:C.amber },
 { label:'Outstanding', value:inr(outstanding), color:C.red },
 ].map(s=>(
 <div key={s.label} style={{ background:C.surface, border:`1px solid ${s.color}33`, borderRadius:12, padding:16 }}>
 <div style={{ fontSize:18, marginBottom:6 }}>{s.icon}</div>
 <div style={{ fontSize:22, fontWeight:900, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:4 }}>{s.label}</div>
 </div>
 ))}
 </div>

 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, overflow:'hidden' }}>
 <table style={{ width:'100%', borderCollapse:'collapse' }}>
 <thead>
 <tr style={{ borderBottom:`1px solid ${C.border}` }}>
 {['Code','Client','Type','Date','Pax','Amount','Balance','Status','Sales By','Actions'].map(h=>(
 <th key={h} style={{ padding:'10px 14px', fontSize:11, color:C.text2, fontWeight:700, textAlign:'left', textTransform:'uppercase' }}>{h}</th>
 ))}
 </tr>
 </thead>
 <tbody>
 {bookings.slice(0,15).map((b,i)=>(
 <tr key={b.id} style={{ borderBottom:`1px solid rgba(30,58,95,.5)`, background:i%2===0?'transparent':C.surface2 }}>
 <td style={{ padding:'10px 14px', fontSize:12, fontWeight:700, color:C.accent }}>{b.booking_code}</td>
 <td style={{ padding:'10px 14px', fontSize:13, color:C.text }}>{b.guest_name||b.company_name||'——'}</td>
 <td style={{ padding:'10px 14px', fontSize:11, color:C.text2 }}>{b.booking_type}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{fmtDate(b.start_date)}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text, textAlign:'center' }}>{b.pax_count}</td>
 <td style={{ padding:'10px 14px', fontSize:12, fontWeight:700, color:C.amber }}>{inr(b.total_amount)}</td>
 <td style={{ padding:'10px 14px', fontSize:12, color:parseFloat(b.balance_amount)>0?C.red:C.accent, fontWeight:600 }}>{inr(b.balance_amount)}</td>
 <td style={{ padding:'10px 14px' }}>
 <span style={{ padding:'2px 8px', borderRadius:99, fontSize:10, fontWeight:700,
 background:b.booking_status==='Confirmed'?`${C.accent}20`:b.booking_status==='Tentative'?`${C.amber}20`:`${C.red}20`,
 color:b.booking_status==='Confirmed'?C.accent:b.booking_status==='Tentative'?C.amber:C.red }}>
 {b.booking_status}
 </span>
 </td>
 <td style={{ padding:'10px 14px', fontSize:12, color:C.text2 }}>{b.salesperson||'——'}</td>
 <td style={{ padding:'10px 14px' }}>
 <button style={{ padding:'4px 10px', background:`${C.accent}15`, border:`1px solid ${C.accent}33`, borderRadius:6, color:C.accent, cursor:'pointer', fontSize:11 }}>View</button>
 </td>
 </tr>
 ))}
 </tbody>
 </table>


 </div>
 {showNewBooking && (

 <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:2000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
 <div style={{ background:'#0F2040', border:'1px solid rgba(30,58,95,.8)', borderRadius:16, padding:24, maxWidth:440, width:'100%' }}>
 <div style={{ fontWeight:800, fontSize:18, color:'#F0F2FF', marginBottom:6 }}>New Booking</div>
 <div style={{ fontSize:13, color:'#A0A8C0', marginBottom:20 }}>Select booking type</div>
 <div style={{ display:'grid', gap:10 }}>
 {[
 { label:'Room Stay', color:'#22C55E', desc:'Overnight accommodation', action:()=>{setShowNewBooking(false);setShowRoomBooking(true);} },
 { label:'Group Booking', color:'#3B82F6', desc:'Day visit or group stay', action:()=>{setShowNewBooking(false);setShowGroupBooking(true);} },
 { label:'Corporate / MICE', color:'#A78BFA', desc:'Corporate events & meetings', action:()=>{setShowNewBooking(false);setShowCorpBooking(true);} },
 { label:'Wedding / Event', color:'#F59E0B', desc:'Weddings & social events', action:()=>{setShowNewBooking(false);setShowWeddingBooking(true);} },
 ].map(b=>(
 <div key={b.label} onClick={b.action}
 style={{ display:'flex', alignItems:'center', gap:14, padding:16, background:'rgba(255,255,255,.04)', border:'1px solid rgba(30,58,95,.8)', borderRadius:12, cursor:'pointer' }}>
 <div style={{ fontSize:26, width:44, height:44, background:b.color+'20', borderRadius:10, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>{b.icon}</div>
 <div>
 <div style={{ fontWeight:700, fontSize:14, color:'#F0F2FF' }}>{b.label}</div>
 <div style={{ fontSize:12, color:'#A0A8C0', marginTop:2 }}>{b.desc}</div>
 </div>
 <div style={{ marginLeft:'auto', color:'#A0A8C0', fontSize:20 }}>—º</div>
 </div>
 ))}
 </div>
 <button onClick={()=>setShowNewBooking(false)}
 style={{ width:'100%', marginTop:14, padding:'11px', background:'none', border:'1px solid rgba(30,58,95,1)', borderRadius:10, color:'#A0A8C0', cursor:'pointer', fontSize:13 }}>
 Cancel
 </button>
 </div>
 </div>
 )}
 {showRoomBooking && <RoomStayBooking onClose={()=>setShowRoomBooking(false)} onSave={()=>{load();setShowRoomBooking(false);}} />}
 {showGroupBooking && <GroupBooking onClose={()=>setShowGroupBooking(false)} onSaved={()=>{load();setShowGroupBooking(false);}} />}
 {showCorpBooking && <CorporateBooking onClose={()=>setShowCorpBooking(false)} onSave={()=>{load();setShowCorpBooking(false);}} />}
 {showWeddingBooking && <WeddingBooking onClose={()=>setShowWeddingBooking(false)} onSave={()=>{load();setShowWeddingBooking(false);}} />}
 </div>

 );
}

// ANALYTICS 
function Analytics({ bookings }) {
 const revenue = bookings.filter(b=>b.booking_status!=='Cancelled').reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 const collected = bookings.filter(b=>b.booking_status!=='Cancelled').reduce((s,b)=>s+parseFloat(b.advance_paid||0),0);
 const paxTotal = bookings.filter(b=>b.booking_status!=='Cancelled').reduce((s,b)=>s+parseInt(b.pax_count||0),0);

 const byType = bookings.reduce((acc,b)=>{
 const t = b.booking_type||'Other';
 acc[t] = (acc[t]||0) + 1;
 return acc;
 },{});

 return (
 <div>
 <div style={{ fontWeight:700, fontSize:18, color:C.text, marginBottom:16 }}> AI Analytics & Insights</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:14, marginBottom:20 }}>
 {[
 { label:'Total Revenue', value:inr(revenue), color:C.amber },
 { label:'Amount Collected',value:inr(collected), color:C.accent },
 { label:'Total Guests', value:paxTotal+' pax',color:'#FFFFFF' },
 ].map(s=>(
 <div key={s.label} style={{ background:C.surface, border:`1px solid ${s.color}33`, borderRadius:12, padding:16, textAlign:'center' }}>
 <div style={{ fontSize:26, fontWeight:900, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:12, color:C.text3, marginTop:6 }}>{s.label}</div>
 </div>
 ))}
 </div>

 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18, marginBottom:16 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14 }}> Bookings by Type</div>
 {Object.entries(byType).map(([type,count])=>(
 <div key={type} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:`1px solid ${C.border}` }}>
 <div style={{ fontSize:13, color:C.text2 }}>{type}</div>
 <div style={{ display:'flex', alignItems:'center', gap:10 }}>
 <div style={{ width:100, height:6, background:'rgba(255,255,255,.1)', borderRadius:3, overflow:'hidden' }}>
 <div style={{ width:`${(count/bookings.length)*100}%`, height:'100%', background:C.accent, borderRadius:3 }} />
 </div>
 <div style={{ fontSize:13, fontWeight:700, color:C.accent, width:20, textAlign:'right' }}>{count}</div>
 </div>
 </div>
 ))}
 </div>

 <div style={{ background:C.surface, border:`1px solid ${C.accent}33`, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14 }}> AI Suggestions</div>
 {[
 { text:'Occupancy is below 60% this weekend —— consider launching a flash offer', color:C.amber },
 { text:`${inr(revenue-collected)} outstanding —— follow up on pending payments`, color:C.red },
 { text:'3 new group booking enquiries this week —— assign to sales team', color:C.accent },
 { text:'Kitchen meal count for tomorrow: review and confirm with chef', color:C.purple },
 ].map((s,i)=>(
 <div key={i} style={{ display:'flex', gap:12, padding:'10px 0', borderBottom:`1px solid ${C.border}` }}>
 <div style={{ fontSize:18, flexShrink:0 }}>{s.icon}</div>
 <div style={{ fontSize:13, color:C.text2, lineHeight:1.6 }}>{s.text}</div>
 </div>
 ))}
 </div>
 </div>
 );
}

// PLACEHOLDER TABS 
function PlaceholderTab({ title, icon }) {
 return (
 <div style={{ textAlign:'center', padding:60 }}>
 <div style={{ fontSize:50, marginBottom:16 }}>{icon}</div>
 <div style={{ fontSize:18, fontWeight:700, color:C.text, marginBottom:8 }}>{title}</div>
 <div style={{ fontSize:13, color:C.text2 }}>Data will appear here as operations are logged in the system</div>
 </div>
 );
}

// OVERVIEW 
function Overview({ bookings, rooms, hkStats }) {
 const todayArrivals = bookings.filter(b=>b.start_date?.slice(0,10)===todayStr&&!['Cancelled','No Show'].includes(b.booking_status));
 const inHouse = bookings.filter(b=>b.booking_status==='Checked In');
 const todayRevenue = bookings.filter(b=>b.start_date?.slice(0,10)===todayStr&&b.booking_status!=='Cancelled').reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 const pendingPayment = bookings.filter(b=>parseFloat(b.balance_amount||0)>0&&b.booking_status!=='Cancelled').length;

 return (
 <div>
 <div style={{ fontWeight:700, fontSize:18, color:C.text, marginBottom:6 }}>Good morning! </div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>
 {new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})} · Live Data
 </div>

 {/* KPI Grid */}
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(160px,1fr))', gap:12, marginBottom:20 }}>
 {[
 { label:"Today's Arrivals", value:todayArrivals.length, color:C.accent, },
 { label:'In-House Guests', value:inHouse.length, color:'#FFFFFF', },
 { label:"Today's Revenue", value:inr(todayRevenue), color:C.amber, icon:'₹' },
 { label:'Pending Payments', value:pendingPayment, color:C.red, },
 { label:'Vacant Clean', value:hkStats?.rooms?.vacant_clean||0, color:C.accent, },
 { label:'Vacant Dirty', value:hkStats?.rooms?.vacant_dirty||0, color:C.amber, },
 { label:'HK Tasks Pending', value:hkStats?.tasks?.pending||0, color:C.red, },
 { label:'Total Rooms', value:hkStats?.rooms?.total||0, color:'#FFFFFF', },
 ].map(s=>(
 <div key={s.label} style={{ background:C.surface, border:`1px solid ${s.color}33`, borderRadius:12, padding:16 }}>
 <div style={{ fontSize:20, marginBottom:6 }}>{s.icon}</div>
 <div style={{ fontSize:24, fontWeight:900, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:4 }}>{s.label}</div>
 </div>
 ))}
 </div>

 {/* Housekeeping widget */}
 {hkStats && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18, marginBottom:16 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14 }}> Housekeeping Status</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:10 }}>
 {[
 { label:'Vacant Clean', value:hkStats.rooms?.vacant_clean||0, color:C.accent },
 { label:'Vacant Dirty', value:hkStats.rooms?.vacant_dirty||0, color:C.amber },
 { label:'Occupied', value:hkStats.rooms?.occupied||0, color:'#FFFFFF' },
 { label:'Tasks Pending', value:hkStats.tasks?.pending||0, color:C.red },
 ].map(s=>(
 <div key={s.label} style={{ background:`${s.color}15`, border:`1px solid ${s.color}33`, borderRadius:10, padding:12, textAlign:'center' }}>
 <div style={{ fontSize:22, fontWeight:900, color:s.color }}>{s.value}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:3 }}>{s.label}</div>
 </div>
 ))}
 </div>
 </div>
 )}

 {/* Today's bookings */}
 {todayArrivals.length > 0 && (
 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14 }}> Today's Arrivals ({todayArrivals.length})</div>
 {todayArrivals.map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:`1px solid ${C.border}`, fontSize:13 }}>
 <span style={{ color:C.text }}>{b.guest_name||b.company_name||'——'}</span>
 <span style={{ color:C.text2 }}>{b.booking_type} · {b.pax_count} pax</span>
 <span style={{ color:C.amber, fontWeight:600 }}>{inr(b.total_amount)}</span>
 </div>
 ))}
 </div>
 )}
 </div>
 );
}

// MAIN GM DASHBOARD 

const API2 = 'https://api.botanix.in/api';
const C2 = { surface:'#0F2040', surface2:'#162A40', border:'rgba(30,58,95,.8)', text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880', accent:'#22C55E', amber:'#F59E0B', red:'#EF4444', blue:'#3B82F6', purple:'#A78BFA' };
const inr2 = n => '₹' + Number(n||0).toLocaleString('en-IN',{maximumFractionDigits:0});
const fmtD = d => d ? new Date(d).toLocaleDateString('en-IN',{day:'2-digit',month:'short'}) : '——';

function StatCard({ icon, label, value, color }) {
 return (
 <div style={{ background:C2.surface, border:'1px solid '+(color||C2.accent)+'33', borderRadius:12, padding:16, textAlign:'center' }}>
 <div style={{ fontSize:22, marginBottom:4 }}>{icon}</div>
 <div style={{ fontSize:26, fontWeight:900, color:color||C2.accent }}>{value}</div>
 <div style={{ fontSize:10, color:C2.text3, marginTop:3 }}>{label}</div>
 </div>
 );
}

function SectionTitle({ children }) {
 return <div style={{ fontWeight:700, fontSize:18, color:C2.text, marginBottom:16 }}>{children}</div>;
}

function EmptyState({ msg }) {
 return <div style={{ textAlign:'center', padding:30, color:C2.text2 }}>{msg}</div>;
}

// MORNING BRIEF 
function MorningBriefTab({ bookings, hkStats }) {
 const todayStr = new Date().toISOString().slice(0,10);
 const arrivals = bookings.filter(b=>b.start_date?.slice(0,10)===todayStr&&!['Cancelled','Checked Out'].includes(b.booking_status));
 const departures = bookings.filter(b=>b.end_date?.slice(0,10)===todayStr&&b.booking_status==='Checked In');
 const inHouse = bookings.filter(b=>b.booking_status==='Checked In');
 const todayRev = bookings.filter(b=>b.start_date?.slice(0,10)===todayStr).reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 return (
 <div>
 <SectionTitle> Morning Brief —— {new Date().toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Arrivals Today" value={arrivals.length} color={C2.accent} />
 <StatCard icon="" label="Departures" value={departures.length} color={C2.amber} />
 <StatCard icon="" label="In-House" value={inHouse.length} color="#FFFFFF" />
 <StatCard icon="" label="Vacant Clean" value={hkStats?.rooms?.vacant_clean||0} color={C2.accent} />
 <StatCard icon="" label="Today Revenue" value={inr2(todayRev)} color={C2.amber} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}>Today's Arrivals</div>
 {arrivals.length===0 && <EmptyState msg="No arrivals today" />}
 {arrivals.map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{b.guest_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.booking_code} · {b.booking_type}</div></div>
 <div style={{ textAlign:'right' }}><div style={{ color:C2.amber }}>{inr2(b.total_amount)}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.pax_count} pax</div></div>
 </div>
 ))}
 </div>
 </div>
 );
}

// APPROVALS 
function ApprovalsTab() {
 return (
 <div>
 <SectionTitle> Pending Approvals</SectionTitle>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:30, textAlign:'center', color:C2.text2 }}>
 No pending approvals at this time
 </div>
 </div>
 );
}

// FRONT OFFICE LIVE 
function FrontOfficeLive({ bookings }) {
 const todayStr = new Date().toISOString().slice(0,10);
 const arrivals = bookings.filter(b=>b.start_date?.slice(0,10)===todayStr&&!['Cancelled','Checked Out'].includes(b.booking_status));
 const inHouse = bookings.filter(b=>b.booking_status==='Checked In');
 const departures = bookings.filter(b=>b.end_date?.slice(0,10)===todayStr&&b.booking_status==='Checked In');
 return (
 <div>
 <SectionTitle> Front Office —— Live Status</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Today's Arrivals" value={arrivals.length} color={C2.accent} />
 <StatCard icon="" label="In-House" value={inHouse.length} color="#FFFFFF" />
 <StatCard icon="" label="Today's Departures" value={departures.length} color={C2.amber} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}>Today's Arrivals</div>
 {arrivals.length===0 && <EmptyState msg="No arrivals today" />}
 {arrivals.map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{b.guest_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.booking_code} · {b.booking_type}</div></div>
 <div style={{ textAlign:'right' }}><div style={{ color:C2.amber }}>{inr2(b.total_amount)}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.pax_count} pax</div></div>
 </div>
 ))}
 </div>
 </div>
 );
}

// HOUSEKEEPING LIVE 
function HousekeepingLive({ hkStats }) {
 const rooms = hkStats?.rooms || {};
 const tasks = hkStats?.tasks || {};
 return (
 <div>
 <SectionTitle> Housekeeping —— Live Status</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Vacant Clean" value={rooms.vacant_clean||0} color={C2.accent} />
 <StatCard icon="" label="Vacant Dirty" value={rooms.vacant_dirty||0} color={C2.amber} />
 <StatCard icon="" label="Occupied" value={rooms.occupied||0} color="#FFFFFF" />
 <StatCard icon="" label="Tasks Pending" value={tasks.pending||0} color={C2.red} />
 <StatCard icon="" label="Tasks Done" value={tasks.completed||0} color={C2.accent} />
 <StatCard icon="" label="Total Rooms" value={rooms.total||0} color={C2.text2} />
 </div>
 {!hkStats && <EmptyState msg="Loading housekeeping data..." />}
 </div>
 );
}

// KITCHEN LIVE 
function KitchenLive() {
 const [data, setData] = React.useState(null);
 React.useEffect(()=>{ fetch(API2+'/notify/kitchen-today').then(r=>r.json()).then(setData).catch(()=>{}); },[]);
 return (
 <div>
 <SectionTitle> Kitchen & F&B —— Today</SectionTitle>
 {!data && <EmptyState msg="Loading kitchen data..." />}
 {data && (
 <>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Today's Bookings" value={data.bookings?.length||0} color={C2.accent} />
 <StatCard icon="" label="Total Covers" value={data.totalPax||0} color={C2.amber} />
 <StatCard icon="" label="Date" value={data.date} color="#FFFFFF" />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}>Bookings with Meals</div>
 {!data.bookings?.length && <EmptyState msg="No bookings today" />}
 {data.bookings?.map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{b.guest_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.booking_code}</div></div>
 <div style={{ color:C2.accent, fontWeight:600 }}>{b.pax_count} pax</div>
 </div>
 ))}
 </div>
 </>
 )}
 </div>
 );
}

// EVENTS TAB 
function EventsTab({ bookings }) {
 const events = bookings.filter(b=>['Wedding','Event','Corporate'].some(t=>b.booking_type?.includes(t)));
 return (
 <div>
 <SectionTitle> Events & Weddings</SectionTitle>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 {events.length===0 && <EmptyState msg="No upcoming events" />}
 {events.map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'10px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div>
 <div style={{ fontWeight:600, color:C2.text }}>{b.guest_name}</div>
 <div style={{ fontSize:11, color:C2.text3 }}>{b.booking_type} · {fmtD(b.start_date)} ←’ {fmtD(b.end_date)}</div>
 </div>
 <div style={{ textAlign:'right' }}>
 <div style={{ color:C2.amber, fontWeight:600 }}>{inr2(b.total_amount)}</div>
 <div style={{ fontSize:11, color:C2.text3 }}>{b.pax_count} pax</div>
 </div>
 </div>
 ))}
 </div>
 </div>
 );
}

// ACTIVITIES TAB 
function ActivitiesTab() {
 const [data, setData] = React.useState([]);
 React.useEffect(()=>{ fetch(API2+'/activities/slots').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[])).catch(()=>{}); },[]);
 return (
 <div>
 <SectionTitle> Activities & Slots</SectionTitle>
 {data.length===0 && <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:30, textAlign:'center', color:C2.text2 }}>No activity slots found</div>}
 </div>
 );
}

// MAINTENANCE TAB 
function MaintenanceTab() {
 const [data, setData] = React.useState([]);
 React.useEffect(()=>{ fetch(API2+'/maintenance').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[])).catch(()=>{}); },[]);
 const pending = data.filter(t=>t.status==='Pending');
 const inProg = data.filter(t=>t.status==='In Progress');
 const done = data.filter(t=>t.status==='Completed');
 return (
 <div>
 <SectionTitle> Maintenance</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Pending" value={pending.length} color={C2.red} />
 <StatCard icon="" label="In Progress" value={inProg.length} color={C2.amber} />
 <StatCard icon="" label="Completed" value={done.length} color={C2.accent} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 {data.length===0 && <EmptyState msg="No maintenance tasks found" />}
 {data.slice(0,10).map((t,i)=>(
 <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{t.title||t.description||'Task'}</div><div style={{ fontSize:11, color:C2.text3 }}>{t.location}</div></div>
 <span style={{ padding:'3px 8px', borderRadius:99, fontSize:10, fontWeight:700, background:t.status==='Completed'?'rgba(34,197,94,.15)':t.status==='In Progress'?'rgba(245,158,11,.1)':'rgba(239,68,68,.1)', color:t.status==='Completed'?C2.accent:t.status==='In Progress'?C2.amber:C2.red }}>{t.status}</span>
 </div>
 ))}
 </div>
 </div>
 );
}

// HORTICULTURE TAB 
function HorticultureTab() {
 const [data, setData] = React.useState([]);
 React.useEffect(()=>{ fetch(API2+'/horticulture').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[])).catch(()=>{}); },[]);
 return (
 <div>
 <SectionTitle> Horticulture</SectionTitle>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 {data.length===0 && <EmptyState msg="No horticulture records found" />}
 {data.slice(0,10).map((t,i)=>(
 <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div style={{ fontWeight:600, color:C2.text }}>{t.plant_name||t.area||'Record'}</div>
 <span style={{ color:C2.text2 }}>{t.status}</span>
 </div>
 ))}
 </div>
 </div>
 );
}

// INVENTORY TAB 
function InventoryTab() {
 const [data, setData] = React.useState([]);
 React.useEffect(()=>{ fetch(API2+'/inventory').then(r=>r.json()).then(d=>setData(Array.isArray(d)?d:[])).catch(()=>{}); },[]);
 const lowStock = data.filter(i=>i.quantity<=i.min_quantity);
 return (
 <div>
 <SectionTitle> Inventory</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Total Items" value={data.length} color={C2.accent} />
 <StatCard icon="" label="Low Stock" value={lowStock.length} color={C2.red} />
 <StatCard icon="" label="OK" value={data.length-lowStock.length} color={C2.accent} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}> Low Stock Items</div>
 {lowStock.length===0 && <EmptyState msg="All items are well stocked!" />}
 {lowStock.map((item,i)=>(
 <div key={i} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{item.item_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{item.category}</div></div>
 <div style={{ textAlign:'right' }}><div style={{ color:C2.red, fontWeight:700 }}>{item.quantity} {item.unit}</div><div style={{ fontSize:11, color:C2.text3 }}>Min: {item.min_quantity}</div></div>
 </div>
 ))}
 </div>
 </div>
 );
}

// ACCOUNTS TAB 
function AccountsTab() {
 const [data, setData] = React.useState(null);
 React.useEffect(()=>{ fetch(API2+'/accounts/summary').then(r=>r.json()).then(setData).catch(()=>{}); },[]);
 return (
 <div>
 <SectionTitle> Accounts Summary</SectionTitle>
 {!data && <EmptyState msg="Loading accounts data..." />}
 {data && (
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(150px,1fr))', gap:12 }}>
 <StatCard icon="" label="Total Revenue" value={inr2(data.total_revenue||0)} color={C2.accent} />
 <StatCard icon="" label="This Month" value={inr2(data.month_revenue||0)} color={C2.amber} />
 <StatCard icon="" label="Pending Payments" value={inr2(data.pending||0)} color={C2.red} />
 </div>
 )}
 </div>
 );
}

// HR TAB 
function HRTab() {
 const [emps, setEmps] = React.useState([]);
 const [att, setAtt] = React.useState([]);
 React.useEffect(()=>{
 const today = new Date().toISOString().slice(0,10);
 fetch(API2+'/hr/employees').then(r=>r.json()).then(d=>setEmps(Array.isArray(d)?d:[])).catch(()=>{});
 fetch(API2+'/hr/attendance?date='+today).then(r=>r.json()).then(d=>setAtt(Array.isArray(d)?d:[])).catch(()=>{});
 },[]);
 return (
 <div>
 <SectionTitle> HR & Staff</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Total Staff" value={emps.length} color={C2.accent} />
 <StatCard icon="" label="Present Today" value={att.length} color={C2.accent} />
 <StatCard icon="" label="Absent Today" value={emps.length-att.length} color={C2.red} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}>Today's Attendance</div>
 {att.length===0 && <EmptyState msg="No attendance records yet today" />}
 {att.map(a=>(
 <div key={a.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{a.employee_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{a.department}</div></div>
 <div style={{ textAlign:'right' }}><div style={{ color:C2.accent }}>{a.check_in?.slice(0,5)}</div><div style={{ fontSize:11, color:C2.amber }}>{a.check_out?.slice(0,5)||'——'}</div></div>
 </div>
 ))}
 </div>
 </div>
 );
}

// ENGINEERING TAB 
function EngineeringTab() {
 return (
 <div>
 <SectionTitle> Engineering</SectionTitle>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:30, textAlign:'center', color:C2.text2 }}>
 Engineering module coming soon
 </div>
 </div>
 );
}

// REPORTS TAB 
function ReportsTab({ bookings }) {
 const thisMonth = new Date().toISOString().slice(0,7);
 const monthBook = bookings.filter(b=>b.start_date?.startsWith(thisMonth));
 const revenue = monthBook.reduce((s,b)=>s+parseFloat(b.total_amount||0),0);
 const confirmed = monthBook.filter(b=>b.booking_status==='Confirmed').length;
 const checkedIn = monthBook.filter(b=>b.booking_status==='Checked In').length;
 return (
 <div>
 <SectionTitle> Reports —— This Month</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(140px,1fr))', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Month Revenue" value={inr2(revenue)} color={C2.accent} />
 <StatCard icon="" label="Bookings" value={monthBook.length} color={C2.blue} />
 <StatCard icon="" label="Confirmed" value={confirmed} color={C2.accent} />
 <StatCard icon="" label="In-House" value={checkedIn} color="#FFFFFF" />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:14, color:C2.text, marginBottom:12 }}>This Month's Bookings</div>
 {monthBook.length===0 && <EmptyState msg="No bookings this month" />}
 {monthBook.slice(0,10).map(b=>(
 <div key={b.id} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid '+C2.border, fontSize:13 }}>
 <div><div style={{ fontWeight:600, color:C2.text }}>{b.guest_name}</div><div style={{ fontSize:11, color:C2.text3 }}>{b.booking_type} · {fmtD(b.start_date)}</div></div>
 <div style={{ textAlign:'right' }}><div style={{ color:C2.amber }}>{inr2(b.total_amount)}</div><span style={{ padding:'2px 6px', borderRadius:99, fontSize:10, background:'rgba(34,197,94,.15)', color:C2.accent }}>{b.booking_status}</span></div>
 </div>
 ))}
 </div>
 </div>
 );
}

// SUSTAINABILITY TAB 
function SustainabilityTab() {
 return (
 <div>
 <SectionTitle> Sustainability</SectionTitle>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:12, marginBottom:20 }}>
 <StatCard icon="" label="Water Saved" value="12,450 L" color={C2.blue} />
 <StatCard icon="" label="Energy Saved" value="2,340 kWh" color={C2.amber} />
 <StatCard icon="" label="Trees Planted" value="48" color={C2.accent} />
 </div>
 <div style={{ background:C2.surface, border:'1px solid '+C2.border, borderRadius:14, padding:18, color:C2.text2, fontSize:13 }}>
 Sustainability tracking module —— full data logging coming soon.
 </div>
 </div>
 );
}

export default function GMDashboard() {
 const [activeTab, setActiveTab] = useState('overview');
 const [hkStats, setHkStats] = useState(null);
 const [gmAlerts, setGmAlerts] = useState(null);
 const [bookings, setBookings] = useState([]);
 const [rooms, setRooms] = useState([]);
 const [loading, setLoading] = useState(true);
 const [showRoomBooking, setShowRoomBooking] = useState(false);
 const [showGroupBooking, setShowGroupBooking] = useState(false);
 const [showCorpBooking, setShowCorpBooking] = useState(false);
 const [showWeddingBooking, setShowWeddingBooking] = useState(false);
 const [showNewBooking, setShowNewBooking] = useState(false);
 const [navOpen, setNavOpen] = useState(true);

 const handleLogout = () => {
 localStorage.removeItem('botanix_user');
 localStorage.removeItem('botanix_token');
 window.location.reload();
 };

 const load = useCallback(async () => {
 setLoading(true);
 try {
 const [b, r, hk, alerts] = await Promise.all([
 fetch(`${API}/bookings`).then(x=>x.json()),
 fetch(`${API}/rooms`).then(x=>x.json()),
 fetch(`${API}/housekeeping/stats`).then(x=>x.json()).catch(()=>null),
 fetch(`${API}/notify/gm-alerts`).then(x=>x.json()).catch(()=>null),
 ]);
 setBookings(Array.isArray(b)?b:[]);
 setRooms(Array.isArray(r)?r:[]);
 if (hk) setHkStats(hk);
 if (alerts) setGmAlerts(alerts);
 } catch {}
 finally { setLoading(false); }
 }, []);

 useEffect(() => { load(); }, [load]);

 const alertCount = gmAlerts?.todayArrivals?.length || 8;
 const approvalCount = 3;

 const getBadge = (badge) => {
 if (badge==='alerts') return alertCount;
 if (badge==='approvals') return approvalCount;
 return 0;
 };

 return (
 <div style={{ display:'flex', height:'100vh', background:C.bg, color:C.text, fontFamily:'Inter,sans-serif', overflow:'hidden' }}>

 {/* SIDEBAR */}
 <div style={{ width:navOpen?220:60, minWidth:navOpen?220:60, background:C.sidebar, borderRight:`1px solid ${C.sidebarBorder}`, display:'flex', flexDirection:'column', transition:'width .2s', overflow:'hidden' }}>

 {/* Logo */}
 <div style={{ padding:'16px 14px', borderBottom:`1px solid ${C.sidebarBorder}`, display:'flex', alignItems:'center', gap:10, flexShrink:0 }}>
 <img src={LOGO} alt="Botanix" style={{ width:36, height:36, borderRadius:8, objectFit:'contain', background:'#fff', padding:2, flexShrink:0 }} onError={e=>e.target.style.display='none'} />
 {navOpen && (
 <div>
 <div style={{ fontSize:14, fontWeight:800, color:'#fff' }}>BOTANIX ERP</div>
 <div style={{ fontSize:10, color:'rgba(255,255,255,.4)' }}>Resort GM Console</div>
 </div>
 )}
 </div>

 {/* Toggle */}
 <button onClick={()=>setNavOpen(p=>!p)}
 style={{ margin:'8px', padding:'6px', background:'rgba(255,255,255,.05)', border:'none', borderRadius:6, color:'rgba(255,255,255,.4)', cursor:'pointer', fontSize:14, textAlign:'center' }}>
 {navOpen?'':''}
 </button>

 {/* Nav items */}
 <div style={{ flex:1, overflowY:'auto', padding:'4px 8px' }}>
 {NAV_SECTIONS.map(sec=>(
 <div key={sec.section} style={{ marginBottom:8 }}>
 {navOpen && <div style={{ fontSize:10, color:'rgba(255,255,255,.25)', fontWeight:700, letterSpacing:'.08em', padding:'8px 4px 4px', textTransform:'uppercase' }}>{sec.section}</div>}
 {sec.items.map(item=>{
 const active = activeTab===item.id;
 const badge = item.badge ? getBadge(item.badge) : 0;
 return (
 <button key={item.id} onClick={()=>setActiveTab(item.id)}
 style={{ width:'100%', display:'flex', alignItems:'center', gap:8, padding:'8px 10px', borderRadius:8, border:'none', cursor:'pointer', background:active?'rgba(34,197,94,.2)':'transparent', color:active?'#22C55E':'rgba(255,255,255,.55)', fontSize:13, fontWeight:active?600:400, marginBottom:2, textAlign:'left', position:'relative' }}>
 <span style={{ fontSize:15, flexShrink:0 }}>{item.icon}</span>
 {navOpen && <span style={{ flex:1 }}>{item.label}</span>}
 {badge>0 && navOpen && (
 <span style={{ padding:'1px 6px', background:C.red, borderRadius:99, fontSize:10, fontWeight:700, color:'#fff' }}>{badge}</span>
 )}
 {badge>0 && !navOpen && (
 <span style={{ position:'absolute', top:4, right:4, width:8, height:8, background:C.red, borderRadius:'50%' }} />
 )}
 </button>
 );
 })}
 </div>
 ))}
 </div>

 {/* Footer */}
 <div style={{ padding:'10px 8px', borderTop:`1px solid ${C.sidebarBorder}`, flexShrink:0 }}>
 <button onClick={load} style={{ width:'100%', padding:'7px', background:'rgba(255,255,255,.05)', border:'none', borderRadius:6, color:'rgba(255,255,255,.4)', cursor:'pointer', fontSize:12, marginBottom:6 }}>
 {navOpen?' Refresh':''}
 </button>
 <button onClick={handleLogout} style={{ width:'100%', padding:'7px', background:'rgba(239,68,68,.1)', border:'1px solid rgba(239,68,68,.2)', borderRadius:6, color:C.red, cursor:'pointer', fontSize:12, fontWeight:600 }}>
 {navOpen?' Logout':''}
 </button>
 </div>
 </div>

 {/* MAIN CONTENT */}
 <div style={{ flex:1, overflowY:'auto', padding:24 }}>
 {loading && <div style={{ textAlign:'center', padding:60, color:C.text2 }}>Loading GM Dashboard—¦</div>}

 {!loading && (
 <>
 {activeTab==='overview' && <Overview bookings={bookings} rooms={rooms} hkStats={hkStats} />}
 {activeTab==='notifications' && <Notifications />}
 {activeTab==='sales' && <GMSales bookings={bookings} />}
 {activeTab==='analytics' && <Analytics bookings={bookings} />}
 {activeTab==='morning_brief' && <MorningBriefTab bookings={bookings} hkStats={hkStats} />}
 {activeTab==='approvals' && <ApprovalsTab />}
 {activeTab==='front_office' && <FrontOfficeLive bookings={bookings} />}
 {activeTab==='housekeeping' && <HousekeepingLive hkStats={hkStats} />}
 {activeTab==='kitchen' && <KitchenLive />}
 {activeTab==='activities' && <ActivitiesTab />}
 {activeTab==='events' && <EventsTab bookings={bookings} />}
 {activeTab==='maintenance' && <MaintenanceTab />}
 {activeTab==='horticulture' && <HorticultureTab />}
 {activeTab==='inventory' && <InventoryTab />}
 {activeTab==='accounts' && <AccountsTab />}
 {activeTab==='hr' && <HRTab />}
 {activeTab==='engineering' && <EngineeringTab />}
 {activeTab==='reports' && <ReportsTab bookings={bookings} />}
 {activeTab==='sustainability'&& <SustainabilityTab />}
 </>
 )}
 </div>
 </div>
 );
}
